import { useState } from 'react';

export const usePreviousTemplate = () => {
  const [previousTemplate, setPreviousTemplate] = useState<'default' | 'staff'>('default');

  return { previousTemplate, setPreviousTemplate };
};
